// extracted by mini-css-extract-plugin
export var heroFullBannerContainer = "HeroFullBanner-module--heroFullBannerContainer--b109c";
export var heroFullContentStyling = "HeroFullBanner-module--heroFullContentStyling--f28e0";
export var heroFullHeadingStyling = "HeroFullBanner-module--heroFullHeadingStyling--4982b";
export var heroFullSlidPosition = "HeroFullBanner-module--heroFullSlidPosition--e13b4";
export var heroFullSlideHeading = "HeroFullBanner-module--heroFullSlideHeading--d0fb8";
export var kickerHeroFull = "HeroFullBanner-module--kickerHeroFull--93bec";